// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"5cc288f2","533":"9d998f2b"}[chunkId] + ".chunk.css";
};